import { abortNavigation, defineNuxtRouteMiddleware, navigateTo } from '#app'

export default defineNuxtRouteMiddleware(async (to, from) => {
  console.log('nav', { to, from })
  if (to.meta.public) {
    return
  }

  const { $authenticated, $isAdmin, $authLoading, $authPromise } = useNuxtApp()

  if ($authLoading.value) {
    console.log('waiting for authPromise')
    await $authPromise.value
  }

  console.debug('auth.global.js', {
    meta: to.meta,
    $authenticated: $authenticated.value,
    $isAdmin: $isAdmin.value,
  })
  if (!$authenticated.value) {
    console.log('redirecting to login', { path: to.fullPath })
    return navigateTo(`/login?redirect=${encodeURIComponent(to.fullPath)}`)
  }
  if (to.meta?.admin && !$isAdmin.value) {
    console.log('aborting due to not admin', { path: to.fullPath })
    return abortNavigation({
      statusCode: 403,
      message: 'Insufficient permission',
      statusMessage: 'Insufficient permission',
    })
  }
})
